import { ProjectStatus } from '../enums/project-status.enum';
import { WorkflowDataDto } from './workflow-data.dto.interface';

/** REV-22155 — a person project as `aumico-be` sends it (`/person-projects`). */
export interface PersonProjectDto {
    projectId: string;
    personId: string;
    /** "Nachname Vorname". */
    personName: string;
    /** Tax period; the FE shows "Steuerperiode <year of periodEnd>". */
    periodStart: string;
    periodEnd: string;
    projectStatus: ProjectStatus;
    assignee?: string | null;
    clerk?: string | null;
    workflowData?: WorkflowDataDto[];
    /** Last sync with the person template (sync hint). */
    lastTimeSynchronizedMM?: string;
    createdAt?: string;
    updatedAt?: string;
}

/** Filter of `GET /person-projects`. */
export interface PersonProjectsFilter {
    personIds?: string[];
    personName?: string;
    /** Mandate manager or clerk; `UNASSIGNED` for none. */
    assignee?: string[];
    projectStatus?: ProjectStatus[];
    /** Year of `periodEnd`. */
    years?: number[];
    tagIds?: string[];
    sortBy?: 'personName' | 'periodEnd' | 'projectStatus';
    sortOrder?: 'ASC' | 'DESC';
}

/** "Nächstes Geschäftsjahr" — preview per person. */
export interface PersonFinancialYearPreviewItemDto {
    personId: string;
    personName: string;
    status: 'READY' | 'SKIP';
    reason?: 'INACTIVE' | 'NO_PROJECT' | 'NOT_FOUND';
    /** `YYYY-MM-DD`. */
    periodStart?: string;
    periodEnd?: string;
}

export interface PersonFinancialYearPreviewDto {
    previews: PersonFinancialYearPreviewItemDto[];
    readyCount: number;
    skipCount: number;
}
